import axios from './axyos';
import type { CaptchaPayload } from './registerApi';

interface LoginData {
    email: string;
    password: string;
}

interface ForgotPasswordData {
    email: string;
    captcha: CaptchaPayload;
}

interface ResetPasswordData {
    token: string;
    password: string;
    confirmPassword: string;
    captcha: CaptchaPayload;
}

interface ResendSignupConfirmationData {
    email: string;
    lang?: string;
}

export const loginApi = (data: LoginData) => {
    return axios.post('/signin', data);
};

export const googleSigninApi = (credential: string) => {
    return axios.post('/auth/google', { credential });
};

export const getMeApi = () => axios.get("/currentUser");

export const signoutApi = () => axios.post("/signout", {});

export const forgotPasswordApi = (data: ForgotPasswordData) => {
    return axios.post("/password/forgot", data);
};

export const resetPasswordApi = (data: ResetPasswordData) => {
    return axios.post("/password/reset", data);
};

export const resendSignupConfirmationApi = (data: ResendSignupConfirmationData) => {
    return axios.post("/signup/resend-confirmation", data);
};
